<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      
      <v-flex md12>
        <app-table
          ref="training_categoryTable"
          title="Training Category"
          :config="config"
        >

        </app-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import config from './config_index.js'

export default {
  data () {
    return { config }
  },
  methods: {
    mounted() {
    },
  }
}
</script>
